import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => {
  const isDark = theme.palette.type === 'dark'

  // Destructuring seguro usando valores padrão para evitar quebras caso a cor suma do tema
  const {
    palette: {
      blue_300: { main: blue300 } = {},
      blue_50: { main: blue50 } = {},
      green_200: { main: green200 } = {},
      green_300: { main: green300 } = {},
      green_500: { main: green500 } = {},
      gray_400: { main: gray400 } = {},
      gray_stroke: { main: grayStroke } = {},
      white_100: { main: white100 } = {},
      yellow_500: { main: yellow500 } = {},
      yellow_100: { main: yellow100 } = {},
      red_50: { main: red50 } = {},
      red_100: { main: red100 } = {},
      dark_50: { main: dark50 } = {},
      dark_400: { main: dark400 } = {},
      dark_stroke: { main: darkStroke } = {}
    } = {}
  } = theme

  return {
    root: {
      width: '100%'
    },
    mainPaper: {
      width: '100%',
      flex: 1,
      padding: theme.spacing(2)
    },
    fullWidth: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      overflowX: 'auto', // Otimização de UX: 'auto' substitui melhor o 'scroll'
      ...theme.scrollbarStyles
    },
    textfield: {
      width: '100%'
    },
    textRight: {
      textAlign: 'right'
    },
    row: {
      padding: theme.spacing(2, 0) // Shorthand limpo
    },
    control: {
      padding: theme.spacing(0, 1) // Shorthand limpo
    },
    buttonContainer: {
      textAlign: 'right',
      padding: theme.spacing(1)
    },

    containerHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    contentHeader: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px'
    },
    titlePage: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      '& h5': {
        fontWeight: '600',
        fontSize: '1.25rem',
        color: blue300
      },
      '& span': {
        color: isDark ? dark50 : gray400
      }
    },
    contentIcon: {
      display: 'flex',
      padding: 10,
      background: isDark ? dark400 : blue50,
      borderRadius: '10px',
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${blue300}`,
      '& svg': {
        color: blue300
      }
    },
    buttonNewQuickMessage: {
      backgroundColor: green200,
      height: 25,
      color: white100,
      borderRadius: 8,
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: blue300,
        boxShadow: 'none'
      }
    },

    //CompaniesMetrics
    containerMetrics: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    boxMetrics: {
      padding: 16,
      borderRadius: 12,
      height: '100%',
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${grayStroke}`,
      maxWidth: '500px'
    },
    boxIconBase: {
      padding: 8,
      marginRight: 12,
      borderRadius: 8,
      display: 'flex'
    },
    boxCompany: {
      backgroundColor: isDark ? dark400 : blue50,
      border: `1px solid ${blue300}`,
      color: blue300
    },
    boxFinancy: {
      backgroundColor: isDark ? dark400 : green300,
      border: `1px solid ${green500}`,
      color: green500
    },
    boxPlans: {
      backgroundColor: isDark ? dark400 : yellow100,
      border: `1px solid ${yellow500}`,
      color: yellow500
    },
    titleCompany: {
      fontWeight: 'bold',
      color: blue300
    },
    titleFinancy: {
      fontWeight: 'bold',
      color: green500
    },
    titlePlans: {
      fontWeight: 'bold',
      color: yellow500
    },
    boxContentResults: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      justifyContent: 'space-between'
    },
    boxBase: {
      padding: '8px 12px',
      borderRadius: 10,
      textAlign: 'center',
      flex: 1
    },
    boxBaseFinancy: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 12px',
      borderRadius: 10,
      flex: 1
    },
    boxTotal: {
      // backgroundColor: blue50,
      border: `1px solid ${blue300}`
    },
    boxActive: {
      // backgroundColor: green300,
      border: `1px solid ${green500}`
    },
    boxInactive: {
      // backgroundColor: red50,
      border: `1px solid ${red100}`
    },
    titleTotal: {
      fontWeight: 700,
      color: blue300
    },
    subtitleTotal: {
      color: blue300
    },
    titleActive: {
      fontWeight: 700,
      color: green500
    },
    titleFinancyActive: {
      fontWeight: 700,
      color: green500,
      marginTop: 2
    },
    titleFinancyLate: {
      color: red100,
      fontWeight: 600
    },
    subtitleActive: {
      color: green500
    },
    subtitleFinancyLate: {
      fontWeight: 'bold',
      color: red100
    },
    subtitleFinancyActive: {
      fontWeight: 'bold',
      color: green500
    },

    cardPlans: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: 8,
      border: isDark ? `1px solid ${darkStroke}` : `1px solid ${grayStroke}`,
      borderRadius: 8
    },
    chipPlans: {
      width: 24,
      height: 24,
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 8,
      fontWeight: 'bold',
      fontSize: '.75rem'
    },
    planName: {
      fontWeight: 500,
      color: isDark ? dark50 : gray400
    },

    boxCustomDateRange:{
      display: 'flex',
      gap: 8,
      marginBottom: 8
    }
  }
})
